import './index.scss'
import wind_preview from '../../../../../../asset/wind-preview.png'
import { waitForGoogleMaps } from '../../../../map/maploader/maploader';

let CompassOverlay;

waitForGoogleMaps(() => {
  CompassOverlay = class extends google.maps.OverlayView {
    constructor(props) {
      super()
      this.iconUrl = props.iconUrl
      this.markerCOlor = props.markerColor
      this.markerData = props.markerData
      this.windsData = props.windsData
      this.updateWindsCallback = props.updateWindsCallback
      this.container = document.createElement('div')
      this._n = document.createElement('img')
      this._ne = document.createElement('img')
      this._e = document.createElement('img')
      this._se = document.createElement('img')
      this._s = document.createElement('img')
      this._sw = document.createElement('img')
      this._w = document.createElement('img')
      this._nw = document.createElement('img')
      this.dirs = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw']
      this.dirDivs = [
        ['n', this._n],
        ['ne', this._ne],
        ['e', this._e],
        ['se', this._se],
        ['s', this._s],
        ['sw', this._sw],
        ['w', this._w],
        ['nw', this._nw]
      ]
    }

    updateWinds(winds) {
      this.dirDivs.forEach(div => {
        if (winds && winds.indexOf(div[0]) !== -1) {
          div[1].style.visibility = 'visible'
        } else {
          div[1].style.visibility = 'hidden'
        }
      })
    }

    buildContent(url, color = '9ECC3B') {
      let colorMarker
      //  = color[0] == '#' ? color : '#' + color
      if (color.length <= 6) {
        colorMarker = color[0] == '#' ? color : '#' + color
      } else {
        colorMarker = color[0] == '#' ? color.substring(2) : '#' + color.substring(2)
      }
      const hasSpaces = url.includes(' ');
      const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
      const content = document.createElement('div');
      content.classList.add('property');
      content.innerHTML = `
      <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Define the clipping path for the circle -->
      <defs>
        <clipPath id="circleClip">
          <circle cx="8" cy="6" r="5" />
        </clipPath>
      </defs>
      <rect width="16" height="16" id="icon-bound" fill="none"></rect>
      <path d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z" fill=${colorMarker}></path>
      <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
      <!-- Image inside the circle with clipping path -->
      <image xlink:href=${imageUrl ? imageUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4" y="1.5" width="8" height="9" clip-path="url(#circleClip)"></image>
      </svg>
    `;
      return content;
    }

    // onAdd() {
    //   const compass = document.createElement('div'),
    //     // pin = document.createElement('img')
    //     pin = document.createElement('div');
    //   compass.className = 'ideal-wind-compass'
    //   if (!this.markerData.extendedData) {
    //     pin.src = this.iconUrl
    //     pin.div = this.buildContent(this.iconUrl, 'red');
    //     pin.appendChild(this.buildContent(this.iconUrl, this.markerCOlor));
    //   }

    //   pin.className = 'ideal-wind-pin'

    //   this.container.className = 'compass-overlay-container'
    //   this.dirDivs.forEach(div => {
    //     div[1].src = wind_preview
    //     div[1].className = `ideal-wind-preview ${div[0]}-wind`
    //     compass.appendChild(div[1])
    //   })

    //   this.container.appendChild(compass)
    //   this.container.appendChild(pin)

    //   this.getPanes().floatPane.appendChild(this.container)
    //   CompassOverlay.preventMapHitsAndGesturesFrom(this.container)
    // }

    onselectwind(wind) {
      if (this.updateWindsCallback) {
        this.updateWindsCallback(wind); // Call the callback to update the parent component's winds
      }
    }

    onAdd() {
      const compass = document.createElement('div'),
        pin = document.createElement('div');
      compass.className = 'ideal-wind-compass';
      if (!this.markerData.extendedData) {
        pin.src = this.iconUrl;
        pin.div = this.buildContent(this.iconUrl, 'red');
        pin.appendChild(this.buildContent(this.iconUrl, this.markerCOlor));
      }

      pin.className = 'ideal-wind-pin';
      this.container.className = 'compass-overlay-container';

      this.dirDivs.forEach(div => {
        div[1].src = wind_preview
        div[1].className = `ideal-wind-preview ${div[0]}-wind`
        compass.appendChild(div[1])
      })

      // Create the circle container parent and inner container
      const circleContainerParent = document.createElement('div');
      circleContainerParent.className = 'circle-container-parent';

      const circleContainer = document.createElement('div');
      circleContainer.className = 'circle-container';

      // Create and append 8 triangular pieces to the circle container
      this.dirs.forEach((item, i) => {
        const piece = document.createElement('div');
        piece.className = 'piece';
        piece.id = (i + 1).toString();
        piece.dataset.value = item;
        circleContainer.appendChild(piece);
      })

      // Append circleContainer to circleContainerParent
      circleContainerParent.appendChild(circleContainer);

      // Add the circle container parent to the main container
      this.container.appendChild(compass);
      this.container.appendChild(pin);
      this.container.appendChild(circleContainerParent);

      // Adding click event to each triangular piece
      circleContainer.querySelectorAll('.piece').forEach(piece => {
        piece.addEventListener('click', (event) => {
          const clickedPiece = event.target; // Get the clicked element
          this.onselectwind(clickedPiece.dataset.value); // Ensure this works
        });
      });

      // Adding click event to the pin
      pin.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevents click event from propagating to the map
      });

      // Adding a click event to the entire compass overlay container
      compass.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevents click event from propagating to the map
      });

      this.getPanes().floatPane.appendChild(this.container);
      CompassOverlay.preventMapHitsAndGesturesFrom(this.container);
    }

    onRemove() {
      this.container.parentElement.removeChild(this.container)
    }

    draw() {
    }
  }
})

export default CompassOverlay
